import { Button } from 'components/Button';
import { IconPlus } from 'components/Shared/Icon';
import { ReactNode } from 'react';

interface ChoiceProps {
  onClick: () => void;
  children: ReactNode;
  className?: string;
  iconClassName?: string;
}

export const Choice = ({ onClick, children, className, iconClassName }: ChoiceProps) => (
  <Button className={className} appearance="tertiary" border="thin" onClick={onClick}>
    <IconPlus className={iconClassName} appearance="flip-45" size="small" />
    {children}
  </Button>
);
